<template>
  <div style="height: 100%">
    <div class="buttonBox" v-if="showButton">
      <div>
        <div class="chooseButton searchButton" @click="deviceParamInfoEdit('1')" v-if="MenuRoleList.indexOf('10')>=0"><i
          class="el-icon-circle-plus-outline"></i>{{ $t('btn_14') }}
        </div>
        <div class="chooseButton searchButton" @click="deviceParamInfoEdit('2')" v-if="MenuRoleList.indexOf('11')>=0"><i
          class="el-icon-edit-outline"></i>{{ $t('btn_15') }}
        </div>
        <div class="chooseButton deleteButton" @click="delEquipmentTypeParameter" v-if="MenuRoleList.indexOf('12')>=0">
          <i class="el-icon-delete"></i>{{ $t('btn_16') }}
        </div>
      </div>
    </div>
    <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableParamData" highlight-current-row
              @current-change="handleCurrentChangeTree"
              border style="width: 100%;height:85%;margin: 10px 0"
              :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
      <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                       :index="getIndex" width="50">
      </el-table-column>
      <el-table-column prop="name" :label="$t('label_343')" align="left">
      </el-table-column>
      <el-table-column prop="type" :label="$t('label_346')" align="center">
        <template slot-scope="scope">
          {{ checkTypeText(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="defaultValue" :label="$t('label_349')" align="left">
        <template slot-scope="scope">
          <p v-if="scope.row.type=='3'||scope.row.type=='4'">{{ scope.row.defaultValue }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="unit" :label="$t('label_670')" align="left">
        <template slot-scope="scope">
          {{ scope.row.unit }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" :label="$t('label_353')" align="left">
        <template slot-scope="scope">
          <popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
        </template>
      </el-table-column>
    </el-table>
    <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
          @parentMethod="searchPage"></Page>

    <el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceParam" append-to-body
               :close-on-click-modal='false'
               width="800px" top="5%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{ $t('label_343') }}</p>
          <div class="mesInput" style="width: 640px">
            <el-input type="textarea" rows="1" maxlength="10" show-word-limit v-model="tableParamDataEdit.name"
                      :disabled="deviceParamTitle==$t('btn_15')"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p style="width: 150px"><span style="color: #ff0000">*</span>{{ $t('label_346') }}</p>
          <div class="mesInput" style="width: 640px">
            <el-radio label="4" v-model="tableParamDataEdit.type">{{ $t('label_138') }}</el-radio>
            <el-radio label="3" v-model="tableParamDataEdit.type">{{ $t('label_141') }}</el-radio>
            <el-radio label="1" v-model="tableParamDataEdit.type">{{ $t('label_145') }}</el-radio>
            <el-radio label="2" v-model="tableParamDataEdit.type">{{ $t('label_149') }}</el-radio>
          </div>
        </div>
        <div class="dialogMes" style="margin-top: -10px">
          <p style="line-height: 30px;padding-top: 80px;width:100px"><span style="color: #ff0000"
                                                                           v-if="tableParamDataEdit.required">*</span>{{ $t('label_209') }}<br><span>
              <el-checkbox :label="$t('label_204')" v-model="tableParamDataEdit.required"></el-checkbox>
            </span>
          </p>
          <div class="mesSelect">
            <div>
              <div class="text" style="display: flex;width: 590px;padding-left:15px">
                <p style="width: 170px">{{ $t('内容') }}</p>
              </div>
              <div class="select" style="display: flex;">
                <div class="selectMes"
                     style="width: 590px;border:1px solid #dedede;padding: 10px;height: 160px;overflow:auto;">
                  <div class="mes" style="display: flex;margin-bottom: 10px" v-for="(item,index) in checkMesList">
                    <el-input style="width: 350px"
                              :disabled="tableParamDataEdit.type=='3'||tableParamDataEdit.type=='4'"
                              v-model="checkMesList[index].value"></el-input>
                    <div class="del" style="padding-top: 13px;margin-left: 20px" v-if="checkMesList.length>1"
                         @click="delCheckList(index)"><i class="el-icon-remove"
                                                         v-if="tableParamDataEdit.type=='1'||tableParamDataEdit.type=='2'"
                                                         style="color: #ff3300;font-size: 20px"></i>
                    </div>
                  </div>
                  <div class="add" style="width: 30px" @click="addChooseList">
                    <i class="el-icon-circle-plus" style="font-size: 22px;color:#0353c1 "
                       v-if="tableParamDataEdit.type=='1'||tableParamDataEdit.type=='2'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="dialogMes">
          <p>单位</p>
          <div class="mesInput">
            <el-select v-model="tableParamDataEdit.unit" style="width: 210px" filterable :placeholder=$t('input_65')
              :disabled="tableParamDataEdit.type=='2'||tableParamDataEdit.type=='1'||tableParamDataEdit.type=='3'"
              clearable>
              <el-option v-for="(item,index) in unitList" :label="item.val" :value="item.val" :key="item.key">
                <p :v-html="item.val">{{item.val}}</p>
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000" v-if="tableParamDataEdit.type=='4'">*</span>{{ $t('label_670') }}</p>
            <div class="mesInput">
              <el-select v-model="tableParamDataEdit.unit" style="width: 210px" filterable :placeholder="$t('input_65')"
                         :disabled="tableParamDataEdit.type=='2'||tableParamDataEdit.type=='1'||tableParamDataEdit.type=='3'"
                         clearable>
                <el-option v-for="(item,index) in unitList" :label="item.val" :value="item.val" :key="item.key">
                  <p :v-html="item.val">{{ item.val }}</p>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 45px " v-if="version==1">
            <p><span style="color: #ff0000">*</span>{{ $t('label_346') }}</p>
            <div class="mesInput">
              <el-select v-model="tableParamDataEdit.mode" style="width: 210px" filterable :placeholder="$t('input_65')"
                         clearable>
                <el-option v-for="(item,index) in modeList" :label="item.val" :value="item.key" :key="item.key">
                  <p :v-html="item.val">{{ item.val }}</p>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000"
                     v-if="tableParamDataEdit.type=='3'||tableParamDataEdit.type=='4'">*</span>{{ $t('label_851') }}</p>
            <div class="mesInput">
              <el-input :placeholder="$t('input_49')" show-word-limit onkeyup="value=value.replace(/[^\d]/g, '')"
                        :disabled="tableParamDataEdit.type=='1'||tableParamDataEdit.type=='2'"
                        v-model="tableParamDataEdit.length" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 45px">
            <p><span style="color: #ff0000" v-if="tableParamDataEdit.type=='4'">*</span>{{ $t('label_850') }}</p>
            <div class="mesInput" style="width: 210px;display: flex">
              <el-input :placeholder="$t('input_49')" show-word-limit onkeyup="value=value.replace(/[^\d]/g, '')"
                        :disabled="tableParamDataEdit.type=='2'||tableParamDataEdit.type=='3'||tableParamDataEdit.type=='1'"
                        v-model="tableParamDataEdit.decimals" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000" v-if="tableParamDataEdit.type=='3'">*</span>{{ $t('label_173') }}</p>
            <div class="mesInput">
              <el-input :placeholder="$t('input_49')" show-word-limit
                        :disabled="tableParamDataEdit.type=='2'||tableParamDataEdit.type=='1'||tableParamDataEdit.type=='4'"
                        v-model="tableParamDataEdit.lineLimit" clearable :input-change="inputChangeMethod"></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 45px">
            <p><span style="color: #ff0000"
                     v-if="tableParamDataEdit.type=='3'||tableParamDataEdit.type=='4'">*</span>{{ $t('label_349') }}</p>
            <div class="mesInput" style="width: 210px;display: flex">
              <el-input :placeholder="$t('input_49')" @input="inputnum" show-word-limit
                        v-model="tableParamDataEdit.defaultValue"
                        :disabled="tableParamDataEdit.type=='1'||tableParamDataEdit.type=='2'" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_178') }}</p>
          <div class="mesInput" style="width: 640px">
            <!-- :input-change="inputChangeMethod" -->
            <el-input type="textarea" :placeholder="$t('input_49')" maxlength="100" rows="3" show-word-limit
                      v-model="tableParamDataEdit.remark" :clearable="true"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="chooseButton sendButton" @click="tableParamDataEditSave">{{ $t('btn_13') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import file from "@/assets/js/file/file.js";
import Page from "@/components/common/page";
import popMesBox from "@/components/list/popover/pop";
import utils from '@/utils/utils'

export default {
  name: "deviceParam",
  components: {
    Page,
    popMesBox,
  },
  props: {
    showButton: {
      type: Boolean,
      default: ''
    },
    needSort: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      saveLoading: false,
      pageNum: 1,
      version: 1,
      pageSize: 10,
      MenuRoleList: [],
      modeList: [],
      tableParamDataEdit: {
        decimals: '',
        defaultValue: "",
        length: '',
        lineLimit: '',
        name: "",
        remark: "",
        required: false,
        sort: '',
        type: '4',
        options: [],
        unit: ""
      },
      checkMesList: [{
        value: ''
      }],
      tableDataTreeInfo: {},
      pageCount: 0,
      deviceParamTitle: this.$t('btn_14'),
      dialogDeviceParam: false,
      tableParamData: [],
      unitList: [],
      searchDataList: {
        deviceId: ''
      },
    }
  },
  methods: {
    inputnum() {
      if (this.tableParamDataEdit.type == '4') {
        let mes = '^(\\-)*(\\d+)\\.(';
        for (var i = 0; i < this.tableParamDataEdit.decimals; i++) {
          mes += '\\d'
        }
        mes = mes + ").*$";
        let knok = new RegExp(mes);
        let text = this.tableParamDataEdit.defaultValue.toString();
        if (text.split('.').length > 1) {
          if (text.split('.')[0].length > this.tableParamDataEdit.length) {
            utils.messageAlert(this.$t('msg_60'), this.$t('label_358'), this.$t('label_100'));
            this.tableParamDataEdit.defaultValue = Number(text.split('.')[0].substr(0, text.split('.')[0].length - 1) + '.' + text.split('.')[1])
          }
          if (text.split('.')[1].length > this.tableParamDataEdit.decimals) {
            utils.messageAlert(this.$t('msg_61'), this.$t('label_358'), this.$t('label_100'));
            this.tableParamDataEdit.defaultValue = this.tableParamDataEdit.defaultValue.replace(knok, '$1$2.$3');
          }
        } else {
          if (text.length > this.tableParamDataEdit.length) {
            this.tableParamDataEdit.defaultValue = Number(text.substr(0, text.length - 1));
          }
        }
      }
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    newMes(id) {
      this.searchDataList.deviceId = id;
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.$refs['pageModel'].setCurrent(this.pageNum);
      this.getEquipmentTypeParameterList(newParam)
    },
    inputChangeMethod() {
    },
    checkUnitText(type) {
      var data = this.unitList.filter(function (item) {
        return item.key == type;
      });
      if (data != '') {
        return data[0].val
      }
    },
    getUnitList() {
      file.getByDictIdALL({dictId: 4, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unitList = data.data
        }
      }).catch((response) => {
        console.log(response)
      });
      // file.getUnitList().then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.unitList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getModeList() {
      file.getByDictIdALL({dictId: 25, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.modeList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(25).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.modeList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    handleClose() {
      this.dialogDeviceParam = false;
      this.tableParamDataEdit = {
        decimals: '',
        defaultValue: "",
        length: '',
        lineLimit: '',
        name: "",
        remark: "",
        required: false,
        sort: '',
        type: '4',
        options: [],
        unit: ""
      };
      this.checkMesList = [{
        value: ''
      }];
    },
    checkTypeText(type) {
      if (type == '1') {
        return this.$t('label_145')
      }
      if (type == '2') {
        return this.$t('label_149')
      }
      if (type == '3') {
        return this.$t('label_141')
      }
      if (type == '4') {
        return this.$t('label_138')
      }
    },
    addChooseList() {
      this.checkMesList.push({
        value: '',
      })
    },
    delCheckList(index) {
      // let start = index - 1;
      this.checkMesList.splice(index, 1);
    },
    getEquipmentTypeParameterList(param) {
      file.getEquipmentTypeParameterList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableParamData = data.data.records;
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    deviceParamInfoEdit(title) {
      if (title == '2') {
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          file.getEquipmentTypeParameterMes(this.tableDataTreeInfo.id).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.deviceParamTitle = this.$t('btn_15');
              this.tableParamDataEdit = data.data;
              this.tableParamDataEdit.type = this.tableParamDataEdit.type.toString();
              if (this.tableParamDataEdit.type == "1" || this.tableParamDataEdit.type == "2") {
                this.checkMesList = JSON.parse(this.tableParamDataEdit.defaultValue);
                this.tableParamDataEdit.defaultValue = "";
              } else {
              }
              if (this.tableParamDataEdit.required == 1) {
                this.tableParamDataEdit.required = true;
              } else {
                this.tableParamDataEdit.required = false;
              }
              this.dialogDeviceParam = true;
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      } else {
        this.dialogDeviceParam = true;
        this.deviceParamTitle = this.$t('btn_14');
      }
    },
    tableParamDataEditSave() {
      this.saveLoading = true;
      if (this.tableParamDataEdit.name == null || this.tableParamDataEdit.name == '') {
        utils.messageAlert(this.$t('msg_134'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(this.tableParamDataEdit.name)) {
        utils.messageAlert(this.$t('msg_135'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (this.tableParamDataEdit.type == null || this.tableParamDataEdit.type == '') {
        utils.messageAlert(this.$t('msg_136'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      //数值
      if (this.tableParamDataEdit.type == "4") {
        if (isNaN(this.tableParamDataEdit.length)) {
          utils.messageAlert(this.$t('msg_137'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
        if (isNaN(this.tableParamDataEdit.decimals)) {
          utils.messageAlert(this.$t('msg_138'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
        if (isNaN(this.tableParamDataEdit.defaultValue)) {
          utils.messageAlert(this.$t('msg_139'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
      }
      //文本
      if (this.tableParamDataEdit.type == "3") {
        if (isNaN(this.tableParamDataEdit.length)) {
          utils.messageAlert(this.$t('msg_140'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
        if (isNaN(this.tableParamDataEdit.lineLimit)) {
          utils.messageAlert(this.$t('msg_141'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
      }
      if (this.deviceParamTitle == this.$t('btn_14')) {
        this.tableParamDataEdit.sort = this.pageCount + 1;
        this.tableParamDataEdit.equipmentTypeId = this.searchDataList.deviceId;
        if (this.tableParamDataEdit.type == "1" || this.tableParamDataEdit.type == "2") {
          let listArr = [];
          for (let i = 0; i < this.checkMesList.length; i++) {
            if (listArr.indexOf(this.checkMesList[i].value) != '-1') {
              utils.messageAlert(this.$t('msg_142'), this.$t('label_358'), this.$t('label_100'));
              this.saveLoading = false;
              return;
            }
            listArr.push(this.checkMesList[i].value)
          }
          this.tableParamDataEdit.defaultValue = JSON.stringify(this.checkMesList)
        } else {

        }
        if (this.tableParamDataEdit.required) {
          this.tableParamDataEdit.required = 1;
        } else {
          this.tableParamDataEdit.required = 0;
        }
        file.saveEquipmentTypeParameter(this.tableParamDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogDeviceParam = false;
            this.tableParamDataEdit = {
              decimals: '',
              defaultValue: "",
              length: '',
              lineLimit: '',
              name: "",
              remark: "",
              required: false,
              sort: '',
              type: '4',
              options: [],
              unit: ""
            };
            this.checkMesList = [{
              value: ''
            }];
            this.search();
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      } else {
        if (this.tableParamDataEdit.type == "1" || this.tableParamDataEdit.type == "2") {
          this.tableParamDataEdit.defaultValue = JSON.stringify(this.checkMesList)
        } else {

        }
        if (this.tableParamDataEdit.required) {
          this.tableParamDataEdit.required = 1;
        } else {
          this.tableParamDataEdit.required = 0;
        }
        file.saveEquipmentTypeParameterEdit(this.tableParamDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogDeviceParam = false;
            this.tableParamDataEdit = {
              decimals: '',
              defaultValue: "",
              length: '',
              lineLimit: '',
              name: "",
              remark: "",
              required: false,
              sort: '',
              type: '4',
              options: [],
              unit: ""
            };
            this.checkMesList = [{
              value: ''
            }];
            this.search();
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      }
    },
    delEquipmentTypeParameter() {
      let param = this.tableDataTreeInfo.id;
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          file.delEquipmentTypeParameter(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.search();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {

        });
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize,
      }
      this.searchPage(param)
    },
  },
  created() {
    this.getUnitList();
    this.getModeList();
    this.MenuRoleList = this.$store.getters.getMenu;
    this.version = this.$store.getters.getVersions;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/deviceParam.vue